import zoomSdk from "@zoom/appssdk";
import { isZoomEmbeddedApp } from "./postLoginRoute";

export const ZOOM_SDK_CAPABILITIES = [
  "authorize",
  "onAuthorized",
  "getRunningContext",
  "getSupportedJsApis",
  "expandApp",
  "onExpandApp",
  "onAppPopout",
  "openUrl",
];

let configuredPath = null;
let configurePromise = null;

export const configureZoomSdk = async () => {
  if (!isZoomEmbeddedApp()) {
    return null;
  }

  const currentPath = `${window.location.pathname}${window.location.search}`;

  if (configuredPath === currentPath && configurePromise) {
    return configurePromise;
  }

  configuredPath = currentPath;
  configurePromise = zoomSdk.config({
    popoutSize: { width: 480, height: 720 },
    capabilities: ZOOM_SDK_CAPABILITIES,
  });

  try {
    return await configurePromise;
  } catch (error) {
    configuredPath = null;
    configurePromise = null;
    throw error;
  }
};

export { zoomSdk };
